import {
  borderTokens,
  colorTokens,
  dimensionTokens,
  layoutTokens,
  radiusTokens,
  spacingTokens,
  typographyTokens,
} from "./tokens";

export const BROWSER_CSS_VARIABLES = Object.freeze({
  "--as-color-ink": colorTokens.ink,
  "--as-color-ink-soft": colorTokens.inkSoft,
  "--as-color-paper": colorTokens.paper,
  "--as-color-surface": colorTokens.surface,
  "--as-color-divider": colorTokens.divider,
  "--as-color-coral": colorTokens.coral,
  "--as-color-sun": colorTokens.sun,
  "--as-color-sky": colorTokens.sky,
  "--as-color-success": colorTokens.success,
  "--as-color-error": colorTokens.error,
  "--as-font-functional": `"${typographyTokens.bodyMd.fontFamily}"`,
  "--as-font-editorial": `"${typographyTokens.displayMd.fontFamily}"`,
  "--as-type-display-lg-size": `${typographyTokens.displayLg.fontSize}px`,
  "--as-type-display-lg-line": `${typographyTokens.displayLg.lineHeight}px`,
  "--as-type-display-md-size": `${typographyTokens.displayMd.fontSize}px`,
  "--as-type-display-md-line": `${typographyTokens.displayMd.lineHeight}px`,
  "--as-type-display-mobile-size":
    `${typographyTokens.displayMobile.fontSize}px`,
  "--as-type-display-mobile-line":
    `${typographyTokens.displayMobile.lineHeight}px`,
  "--as-type-heading-lg-size": `${typographyTokens.headingLg.fontSize}px`,
  "--as-type-heading-lg-line": `${typographyTokens.headingLg.lineHeight}px`,
  "--as-type-heading-md-size": `${typographyTokens.headingMd.fontSize}px`,
  "--as-type-heading-md-line": `${typographyTokens.headingMd.lineHeight}px`,
  "--as-type-body-lg-size": `${typographyTokens.bodyLg.fontSize}px`,
  "--as-type-body-lg-line": `${typographyTokens.bodyLg.lineHeight}px`,
  "--as-type-body-md-size": `${typographyTokens.bodyMd.fontSize}px`,
  "--as-type-body-md-line": `${typographyTokens.bodyMd.lineHeight}px`,
  "--as-type-label-lg-size": `${typographyTokens.labelLg.fontSize}px`,
  "--as-type-label-lg-line": `${typographyTokens.labelLg.lineHeight}px`,
  "--as-type-label-sm-size": `${typographyTokens.labelSm.fontSize}px`,
  "--as-type-label-sm-line": `${typographyTokens.labelSm.lineHeight}px`,
  "--as-letter-spacing": "0",
  "--as-space-base": `${spacingTokens.base}px`,
  "--as-space-2": `${spacingTokens[2]}px`,
  "--as-space-3": `${spacingTokens[3]}px`,
  "--as-space-4": `${spacingTokens[4]}px`,
  "--as-space-6": `${spacingTokens[6]}px`,
  "--as-space-8": `${spacingTokens[8]}px`,
  "--as-layout-mobile-margin": `${layoutTokens.mobileMargin}px`,
  "--as-layout-desktop-margin": `${layoutTokens.desktopMargin}px`,
  "--as-layout-gutter": `${layoutTokens.gutter}px`,
  "--as-layout-share-rail-min": `${layoutTokens.desktopShareRailMin}px`,
  "--as-layout-share-rail-max": `${layoutTokens.desktopShareRailMax}px`,
  "--as-breakpoint-mobile": `${layoutTokens.mobileBreakpoint}px`,
  "--as-breakpoint-desktop": `${layoutTokens.desktopBreakpoint}px`,
  "--as-radius-sm": `${radiusTokens.sm}px`,
  "--as-radius-md": `${radiusTokens.md}px`,
  "--as-radius-lg": `${radiusTokens.lg}px`,
  "--as-border-default": `${borderTokens.default}px`,
  "--as-touch-target": `${dimensionTokens.touchTarget}px`,
  "--as-control-height": `${dimensionTokens.primaryControlHeight}px`,
  "--as-icon-compact": `${dimensionTokens.compactIcon}px`,
  "--as-icon-standard": `${dimensionTokens.standardIcon}px`,
  "--as-progress-height": `${dimensionTokens.progressBarHeight}px`,
} as const);

export function renderBrowserTokenCss(): string {
  const variables = Object.entries(BROWSER_CSS_VARIABLES)
    .map(([name, value]) => `  ${name}: ${value};`)
    .join("\n");
  return [
    "/* Generated from @aasaan-share/ui-contract tokens. */",
    ":root {",
    variables,
    "}",
    "",
  ].join("\n");
}
